module.exports = __webpack_public_path__ + "static/media/logo.f0e9a28c.png";